import Image from 'next/image'
import Footer from '../components/Footer'
// import Link from 'next/link'
import { ExternalLinkIcon, XIcon, ZoomInIcon } from '@heroicons/react/outline'
import RosPostcardIcon from '../Icons/templates/ros-postcard.svg'
import SnapPack from '../Icons/templates/snap-pack.svg'
// import LargePostcards from '../Icons/templates/large-postcard.svg'
import SmallPostcards from '../Icons/templates/small-postcard.svg'
import StreetView from '../Icons/templates/streetview.svg'
import RealPennedPostcard from '../Icons/templates/real-penned-postcard.svg'
import RosLetterIcon from '../Icons/templates/ros-letter.svg'
import RealPennedPersonal from '../Icons/templates/real-penned-personal.svg'
import RealPennedProfessional from '../Icons/templates/real-penned-professional.svg'
import PersonalLetterIcon from '../Icons/templates/personal-letters.svg'
import ProfessionalLetterIcon from '../Icons/templates/professional.svg'
import Feature1 from '../Icons/templates/features/1.svg'
import Feature2 from '../Icons/templates/features/2.svg'
import Feature3 from '../Icons/templates/features/3.svg'
import Feature4 from '../Icons/templates/features/4.svg'
import Feature5 from '../Icons/templates/features/5.svg'
import Category from '../Icons/templates/search/category.svg'
import ProductType from '../Icons/templates/search/product-type.svg'

import TriFoldIcon from '../Icons/templates/tri-fold.svg'
// import Header from '../components/Header'
// import { Container } from '../components/Container'
import { useEffect, useState } from 'react'
import ZoomModal from '../components/Modals/ZoomModal'
import ShallowHeader from '../components/ShallowHeader'
import SectionSubText from '../components/HomePage/SectionSubText'
import ListBox2 from '../components/Inputs/ListBox2'
import { Combobox } from '@headlessui/react'
import HeroHeading from '../components/Headings/HeroHeading'
import { GeneralAPI } from '../apis/GeneralAPI'

const pillsColors = ['bg-orange', 'bg-yellow', 'bg-red', 'bg-green', 'bg-blue']

const removeSpace = (str) => {
    return str.replace(/\s/g, '-')
}

const Icons = {
    'ROS Postcards': RosPostcardIcon,
    'Snap Pack Check Mailers (ROS)': SnapPack,
    'Small Postcards': SmallPostcards,
    'Large Postcards': SmallPostcards,
    'Real Penned Postcards': RealPennedPostcard,
    'Streetview Postcards': StreetView,
    'ROS Letters': RosLetterIcon,
    'Real Penned Personal Letters': RealPennedPersonal,
    'Real Penned Professional Letters': RealPennedProfessional,
    'Personal Letters': PersonalLetterIcon,
    'Professional Letters': ProfessionalLetterIcon,
    'Tri-Fold Flyers': TriFoldIcon,
}

const ProductTypes = Object.keys(Icons).map((key) => {
    return {
        name: key,
        slug: removeSpace(key),
    }
})

const features = {
    'Fast Turnaround': Feature1,
    'Proven ROI': Feature2,
    'Expertly Crafted Designs': Feature3,
    'Precision Targeting': Feature4,
    'Satisfaction Guaranteed': Feature5,
}

const DynamicIcon = ({ productName, Icon, ...props }) => {
    const IconComponent = Icon ?? Icons[productName]
    if (!IconComponent) return null // Handle cases where product name doesn't match any icon
    return <IconComponent {...props} />
}

export default function Templates({ data, pageData, categories = [] }) {
    const [zoomModalOpen, setZoomModalOpen] = useState(false)
    const [currentImageIndex, setCurrentImageIndex] = useState(0)
    const [currentImages, setCurrentImages] = useState([])
    const [activeHash, setActiveHash] = useState('')
    const [selectedProductType, setSelectedProductType] = useState([])
    const [selectedCategory, setSelectedCategory] = useState([])

    const [query, setQuery] = useState('')
    const [debouncedQuery, setDebouncedQuery] = useState('')

    const [allSelectedPills, setAllSelectedPills] = useState([])

    const [filteredData, setFilteredData] = useState(data)

    const openZoomModal = (templates, product, idx) => {
        const templatesToUse = templates.map(({ template }) => {
            return {
                ...template,
                link: generateURL(product, template),
            }
        })

        setCurrentImages(templatesToUse)
        setCurrentImageIndex(idx)
        setZoomModalOpen(true)
    }

    const closeZoomModal = () => {
        setZoomModalOpen(false)
    }

    const generateURL = (product, template) => {
        return `product/${product.slug}?template=${
            template.url
        }&templateName=${encodeURIComponent(template.name)}`
    }

    const handleProductType = (selected) => {
        setSelectedProductType(selected)
    }

    const handleRemoveProductType = (product) => {
        setSelectedProductType((prev) => {
            return prev.filter((item) => item.name !== product.name)
        })
    }

    const handleRemoveCategory = (product) => {
        setSelectedCategory((prev) => {
            return prev.filter((item) => item.name !== product.name)
        })
    }

    const handleRemovalPill = (product) => {
        const functionToUser =
            product.type === 'category'
                ? handleRemoveCategory
                : handleRemoveProductType
        functionToUser(product)
    }

    useEffect(() => {
        if (debouncedQuery === '') {
            setFilteredData(data)
            return
        }

        const filtered = data
            .map((product) => ({
                ...product,
                acf: {
                    ...product.acf,
                    templates_and_attributes:
                        product.acf.templates_and_attributes.filter(
                            ({ template }) => {
                                // Log template names to ensure we're checking the correct field
                                console.log('Template Name:', template.name)
                                return (
                                    debouncedQuery === '' ||
                                    (template.name &&
                                        template.name
                                            .toLowerCase()
                                            .includes(
                                                debouncedQuery.toLowerCase(),
                                            ))
                                )
                            },
                        ),
                },
            }))
            .filter(
                (product) => product.acf.templates_and_attributes.length > 0,
            )

        console.log('Filtered Data:', filtered) // Check filtered data after filtering
        setFilteredData(filtered)
    }, [debouncedQuery, data])

    // Apply a 500ms debounce delay for the search query
    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery(query)
            console.log('Debounced Query:', query) // Debugging: Check query being debounced
        }, 500)
        return () => {
            clearTimeout(handler)
        }
    }, [query])

    // Extract the URL fragment and set the active hash
    useEffect(() => {
        const hash = window.location.hash
        setActiveHash(hash)
    }, [])

    useEffect(() => {
        const categories = selectedCategory.map((item) => {
            return {
                name: item.name,
                type: 'category',
            }
        })
        const products = selectedProductType.map((item) => {
            return {
                name: item.name,
                type: 'product',
            }
        })
        setAllSelectedPills([...categories, ...products])
    }, [selectedProductType, selectedCategory])

    useEffect(() => {
        if (allSelectedPills.length > 0) {
            const selectedNames = allSelectedPills.map((pill) => pill.name) // Extract names

            // Filter products and their templates based on selected categories
            const filtered = data
                .map((product) => {
                    // Check if product name matches (for Product Type filter)
                    const productNameMatches = selectedNames.some(
                        (selectedName) => product.name.includes(selectedName),
                    )

                    // Filter templates by industry (for Category filter)
                    const filteredTemplates =
                        product.acf?.templates_and_attributes?.filter(
                            ({ template }) =>
                                selectedNames.some(
                                    (selectedName) =>
                                        template.industry === selectedName,
                                ),
                        ) || []

                    // If product name matches, return all templates
                    if (productNameMatches) {
                        return product
                    }

                    // If some templates match the category, return product with filtered templates
                    if (filteredTemplates.length > 0) {
                        return {
                            ...product,
                            acf: {
                                ...product.acf,
                                templates_and_attributes: filteredTemplates,
                            },
                        }
                    }

                    return null
                })
                .filter((product) => product !== null)

            setFilteredData(filtered)
        } else {
            setFilteredData(data)
        }
    }, [allSelectedPills, data])

    return (
        <div>
            <ShallowHeader title={'Templates'} meta={pageData?.yoast_head} />
            <div className="m-auto max-h-[40vh] border overflow-hidden ">
                <Image
                    className="hidden md:block w-full"
                    src="/assets/templates/hero.png"
                    alt="templates"
                    title="templates"
                    width={1600}
                    height={640}
                />
                <Image
                    className="md:hidden"
                    src="/assets/templates/mobile-hero.png"
                    alt="templates"
                    title="templates"
                    width={768}
                    height={480}
                />
            </div>
            <div className="bg-light-yellow-gradient-transparent">
                <div
                    id="#DirectMailTemplates"
                    className="container m-auto pt-10 text-center">
                    <HeroHeading className="text-center">
                        Direct Mail Templates
                    </HeroHeading>
                    <SectionSubText size="max-w-4xl">
                        Drive motivated sellers to take action! Our customizable
                        direct mail templates are designed for real estate
                        investors to attract property sellers. Quickly add your
                        details and property offers to create attention-grabbing
                        pieces that deliver results straight to mailboxes.
                    </SectionSubText>

                    <div className="md:flex space-y-2 md:space-y-0 justify-between max-w-5xl md:m-auto md:my-10 mx-6 my-6">
                        {Object.keys(features).map((key, idx) => {
                            return (
                                <div
                                    key={idx}
                                    className="flex border px-4 py-1 border-olm rounded-full items-center">
                                    <DynamicIcon
                                        productName={key}
                                        className="w-6"
                                        Icon={features[key]}
                                    />
                                    <span>{key}</span>
                                </div>
                            )
                        })}
                    </div>

                    {/* <div className="text-center">
                        {Object.keys(Icons).map((key, idx) => {
                            return (
                                <a
                                    key={idx}
                                    href={`#${removeSpace(key)}`}
                                    className="text-xs inline-block uppercase p-2 mx-2 my-1 font-semibold bg-orange-200 rounded-md justify-center items-center">
                                    {key}
                                </a>
                            )
                        })}
                    </div> */}
                </div>

                <div className="py-10 container m-auto">
                    <div className="items-center space-y-4 md:space-y-0 md:grid md:grid-cols-4 mx-2 gap-4 justify-between">
                        <Combobox value={query} onChange={setQuery}>
                            <div className="relative w-full md:col-span-2">
                                <span className="absolute inset-y-0 left-3 flex items-center">
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        className="h-5 w-5 text-gray-400"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        stroke="currentColor"
                                        strokeWidth="2">
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M21 21l-4.35-4.35m2.7-7.8a7.5 7.5 0 11-15 0 7.5 7.5 0 0115 0z"
                                        />
                                    </svg>
                                </span>
                                <Combobox.Input
                                    className="pl-10 p-2 max-w-full w-full h-16 text-xl rounded-lg bg-transparent shadow-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-200"
                                    placeholder="Search Templates"
                                    onChange={(e) => setQuery(e.target.value)}
                                />
                                {
                                    // Display the search query
                                    query && (
                                        <span className="absolute inset-y-0 right-3 flex items-center">
                                            <XIcon
                                                className="h-5 w-5 text-gray-400 cursor-pointer"
                                                onClick={() => setQuery('')}
                                            />
                                        </span>
                                    )
                                }
                            </div>
                        </Combobox>
                        <ListBox2
                            options={ProductTypes}
                            onSelect={handleProductType}
                            placeholder="Product Type"
                            className="h-16 bg-olm"
                            Icon={ProductType}
                            valueFromParent={selectedProductType}
                        />
                        <ListBox2
                            onSelect={setSelectedCategory}
                            valueFromParent={selectedCategory}
                            options={categories}
                            placeholder="Industry"
                            Icon={Category}
                            className="h-16 bg-olm"
                        />
                    </div>

                    <div className="pt-10">
                        {Object.values(allSelectedPills).map((product) => {
                            const name = product.name
                            // Select a random color for each product pill
                            const randomColor =
                                pillsColors[
                                    Math.floor(
                                        Math.random() * pillsColors.length,
                                    )
                                ]
                            return (
                                <button
                                    onClick={() => handleRemovalPill(product)}
                                    key={name}
                                    className={`${randomColor}-100 hover:${randomColor}-200 inline-flex m-2 rounded-full items-center space-x-1 px-10 py-4 text-xl`}>
                                    <XIcon className="h-5 w-5" />
                                    <span>{name}</span>
                                </button>
                            )
                        })}
                    </div>
                </div>

                <div className="container m-auto flex items-start md:space-x-10">
                    <div className="w-3/12 space-y-4 my-10 hidden md:block py-3 px-4 bg-olm-light-yellow rounded-xl sticky top-10 overflow-y-auto">
                        {filteredData.map((product, idx) => {
                            const key = product.name
                            const itemHash = `#${removeSpace(key)}`
                            return (
                                <a
                                    key={idx}
                                    href={itemHash}
                                    onClick={() => setActiveHash(itemHash)}
                                    className={`p-2 mx-2 my-1 flex px-4 space-x-2
                                        ${
                                            activeHash === itemHash
                                                ? 'bg-olm-light-primary'
                                                : 'hover:bg-olm-light-primary'
                                        }
                                        rounded-full items-center`}>
                                    <div className="w-2/12">
                                        <DynamicIcon
                                            productName={key}
                                            className="w-6"
                                        />
                                    </div>
                                    <span>{key}</span>
                                </a>
                            )
                        })}
                    </div>

                    <div className="md:w-9/12 w-full">
                        {filteredData.map((product, idx) => (
                            <div id={removeSpace(product.name)} key={idx}>
                                <div className="space-y-10 pt-10">
                                    <h3 className="text-3xl text-left items-center font-semibold md:flex flex-row justify-left space-x-4">
                                        <div className="text-center space-y-4 md:space-x-4 items-center justify-center md:justify-left md:py-2">
                                            <DynamicIcon
                                                productName={product.name}
                                                className="w-12 m-auto md:inline-block"
                                            />
                                            <p className="md:inline-block">
                                                {product.name}
                                            </p>
                                        </div>
                                    </h3>

                                    <div className="flex flex-wrap justify-center">
                                        {product?.acf?.templates_and_attributes?.map(
                                            ({ template }, idx) =>
                                                template.url && (
                                                    <div key={idx}>
                                                        <h3 className="text-center py-2">
                                                            {template.name}
                                                        </h3>
                                                        <div className="relative group md:basis-1/3 p-2">
                                                            {/* <Link
                                                            href={generateURL(
                                                                product,
                                                                template,
                                                            )}> */}
                                                            <a
                                                                href={generateURL(
                                                                    product,
                                                                    template,
                                                                )}>
                                                                <Image
                                                                    height={314}
                                                                    width={284}
                                                                    src={
                                                                        template?.url ||
                                                                        '/'
                                                                    }
                                                                    alt={
                                                                        template?.name
                                                                    }
                                                                    title={
                                                                        template?.name
                                                                    }
                                                                    loading="lazy"
                                                                    className="rounded-lg"
                                                                />
                                                                <br />
                                                            </a>
                                                            <div className="hidden md:block">
                                                                <span className="absolute inset-0 opacity-0 group-hover:opacity-50 bg-gray-50"></span>
                                                                <div className="absolute space-y-4 w-48 text-center items-center left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2  text-black px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity">
                                                                    {/* <Link
                                                                    href={generateURL(
                                                                        product,
                                                                        template,
                                                                    )}> */}
                                                                    <a
                                                                        href={generateURL(
                                                                            product,
                                                                            template,
                                                                        )}
                                                                        className="bg-gray-300 flex items-center p-2 py-1 rounded-lg">
                                                                        <span className="mr-2">
                                                                            edit
                                                                            this
                                                                            template
                                                                        </span>
                                                                        <ExternalLinkIcon className="h-4 w-4" />
                                                                    </a>
                                                                    {/* </Link> */}
                                                                    {/* Zoom Button */}
                                                                    <button
                                                                        onClick={() =>
                                                                            openZoomModal(
                                                                                product
                                                                                    .acf
                                                                                    .templates_and_attributes,
                                                                                product,
                                                                                idx,
                                                                            )
                                                                        }
                                                                        className="bg-gray-300 px-2 py-1 rounded text-black">
                                                                        <ZoomInIcon className="h-5 w-5" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className="md:hidden text-center justify-center space-y-4 my-2">
                                                                <div className="text-xl items-center inline-flex m-auto rounded-lg bg-gray-300 hover:bg-olm hover:text-white px-2 py-1">
                                                                    <span className="mr-2">
                                                                        edit
                                                                        this
                                                                        template
                                                                    </span>
                                                                    <ExternalLinkIcon className="h-6 w-6" />
                                                                </div>
                                                                <div>
                                                                    <button
                                                                        onClick={() =>
                                                                            openZoomModal(
                                                                                product
                                                                                    .acf
                                                                                    .templates_and_attributes,
                                                                                idx,
                                                                            )
                                                                        }
                                                                        className="ml-2 bg-gray-300 px-2 py-1 rounded-lg text-black">
                                                                        <ZoomInIcon className="h-6 w-6" />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ),
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {zoomModalOpen && (
                    <ZoomModal
                        images={currentImages}
                        currentImageIndex={currentImageIndex}
                        onClose={closeZoomModal}
                    />
                )}
            </div>
            <Footer />
        </div>
    )
}

const getCategoriesFromProducts = (products = []) => {
    const industries = products.flatMap(
        (product) =>
            product?.acf?.templates_and_attributes
                ?.map((item) => item?.template?.industry)
                .filter(Boolean) || [],
    )

    return [...new Set(industries)].map((name) => ({ name }))
}

// This function gets called at build time on server-side.
// It may be called again, on a serverless function, if
// revalidation is enabled and a new request comes in
export async function getStaticProps() {
    // const page = await GeneralAPI.getPageBySlug('/about')

    const ProductAPI = (await import('../apis/server/ProductAPI')).ProductAPI

    const slugs = [
        'snap-pack-check-mailers-ros',
        'postcards',
        'real-penned-postcards',
        'ros-letters',
        'real-penned-letters',
        'real-penned-professional-letters',
        'personal-letters',
        'professional-letters',
        'tri-fold-flyers',
    ]

    const _data = await Promise.all(
        slugs.map(async (slug) => {
            const { data } = await ProductAPI.getProductsBySlug(slug)
            return data[0]
        }),
    )
    const page = await GeneralAPI.getPageBySlug('/templates')
    const pageData = page ? page[0] : {}

    // Fetch categories from ACF options (industries repeater field)
    let categories = getCategoriesFromProducts(_data)

    try {
        const { data: industriesData } = await GeneralAPI.getACFOptions(
            'options/industries',
        )
        const fetchedCategories =
            industriesData?.industries
                ?.map((ind) => ind?.name)
                .filter(Boolean)
                .map((name) => ({ name })) || []

        if (fetchedCategories.length > 0) {
            categories = fetchedCategories
        }
    } catch (error) {
        console.warn(
            'Templates page industries fallback used because ACF options industries could not be loaded.',
            error?.message || error,
        )
    }

    return {
        props: {
            data: _data,
            pageData: pageData,
            categories: categories,
        },
        revalidate: 10, // In seconds
    }
}
